import React from 'react'
import classNames from 'classnames'
import { motion } from 'framer-motion'
import { UploadIcon } from '@/atoms/Icons/UploadIcon'
import { AsSpan, LabelLG } from '@/atoms/Text'
import { useTranslate } from '@/utils/translate/translate-client'

interface Props {
  onClick: () => void
  className?: string
}

export const FloatingShareButton: React.FC<Props> = ({ onClick, className }) => {
  const { t } = useTranslate('tickets')

  return (
    <motion.button
      initial={{ y: 100, opacity: 0 }}
      animate={{
        y: 0,
        opacity: 1,
        transition: { type: 'tween', duration: 0.3 },
      }}
      onClick={onClick}
      className={classNames(
        'flex items-center gap-1 bg-giveaway-secondary-accent p-3.5 px-6 drop-shadow-md fixed right-6 z-50 rounded-xl',
        className,
      )}
    >
      <LabelLG as={AsSpan} color="giveaway-background-primary-light" weight="normal">
        {t('share', 'Share')}
      </LabelLG>
      <UploadIcon size={28} color="giveaway-background-primary-light" />
    </motion.button>
  )
}
